import React from 'react';
import { Check, Target } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Cómo pensar como jugador ganador', 'Cómo tomar decisiones bajo presión', 'Cómo posicionarte mejor', 'Cómo elegir enfrentamientos', 'Cómo dejar de regalar partidas por emoción', 'Cómo entrenar con intención'];
  return <section className="py-24 bg-slate-900 relative" data-id="element-152">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-blue-900/20 to-transparent" data-id="element-153" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-154">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-155">
          <div className="flex-1" data-id="element-156">
            <div className="flex items-center gap-3 mb-6" data-id="element-157">
              <Target className="w-8 h-8 text-blue-500" data-id="element-158" />
              <span className="text-blue-500 font-bold tracking-widest uppercase" data-id="element-159">
                La Solución
              </span>
            </div>

            <h2 className="text-4xl md:text-6xl font-black text-white mb-8 leading-none" data-id="element-160">
              EL SISTEMA QUE TE DA <br data-id="element-161" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400" data-id="element-162">
                VENTAJA REAL
              </span>
            </h2>

            <p className="text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-163">
              <span className="text-white font-bold" data-id="element-164">
                "Dominio Total en Free Fire"
              </span>{' '}
              no es un manual lleno de relleno. Es un sistema estratégico
              diseñado para que en 7 días juegues con más control, más
              inteligencia y más seguridad.
            </p>

            <div className="grid gap-4" data-id="element-165">
              {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-4 group" data-id="element-166">
                  <div className="w-8 h-8 rounded bg-blue-900/50 flex items-center justify-center border border-blue-500/30 group-hover:bg-blue-500 group-hover:text-white transition-colors" data-id="element-167">
                    <Check className="w-5 h-5 text-blue-400 group-hover:text-white" data-id="element-168" />
                  </div>
                  <span className="text-lg text-slate-200 font-medium" data-id="element-169">
                    {benefit}
                  </span>
                </div>)}
            </div>

            <div className="mt-12 p-6 bg-slate-800/50 border-l-4 border-blue-500 rounded-r-lg" data-id="element-170">
              <p className="text-xl font-bold text-white" data-id="element-171">
                Esto no es motivación.{' '}
                <span className="text-blue-400" data-id="element-172">Es ventaja competitiva.</span>
              </p>
            </div>
          </div>

          <div className="flex-1 w-full" data-id="element-173">
            <div className="relative" data-id="element-174">
              <div className="absolute inset-0 bg-blue-600 blur-[100px] opacity-20" data-id="element-175" />
              <div className="relative bg-slate-950 border border-slate-800 p-2 rounded-xl shadow-2xl transform rotate-2 hover:rotate-0 transition-all duration-500" data-id="element-176">
                {/* Placeholder for an interior page or abstract graphic representing the system */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}